import { render } from "./LoginForm.vue?vue&type=template&id=497ba712&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"

import "./LoginForm.vue?vue&type=style&index=0&id=497ba712&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-497ba712"

export default script